import { Box, BoxProps } from '@air/zephyr';

export interface ListItemProps extends BoxProps<'li'> {}

export const ListItem = ({ tx, ...restOfProps }: ListItemProps) => {
  return <Box as="li" {...restOfProps} tx={{ mb: 8, ...tx }} />;
};

export interface OrderedListProps extends BoxProps<'ol'> {}

export const OrderedList = ({ tx, ...restOfProps }: OrderedListProps) => {
  return <Box as="ol" {...restOfProps} tx={{ pl: 24, ...tx }} />;
};

export interface UnorderedListProps extends BoxProps<'ul'> {}

export const UnorderedList = ({ tx, ...restOfProps }: UnorderedListProps) => {
  return <Box as="ul" {...restOfProps} tx={{ pl: 24, ...tx }} />;
};
